var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52581 10.5168C10.6212 10.5168 11.5091 9.62887 11.5091 8.5335C11.5091 7.43814 10.6212 6.55017 9.52581 6.55017C8.43045 6.55017 7.54248 7.43814 7.54248 8.5335C7.54248 9.62887 8.43045 10.5168 9.52581 10.5168Z",
    stroke: "#292D32",
    strokeWidth: 1.37759,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4928 2.58337H9.52614C4.56781 2.58337 2.58447 4.56671 2.58447 9.52504V15.475C2.58447 20.4334 4.56781 22.4167 9.52614 22.4167H15.4761C20.4345 22.4167 22.4178 20.4334 22.4178 15.475V10.5167",
    stroke: "#292D32",
    strokeWidth: 1.37759,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2192 5.55798H21.6734",
    stroke: "#292D32",
    strokeWidth: 1.37759,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9465 8.28559V2.83142",
    stroke: "#292D32",
    strokeWidth: 1.37759,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24805 19.3919L8.13696 16.1095C8.92038 15.5839 10.0509 15.6434 10.755 16.2483L11.0822 16.5359C11.8557 17.2003 13.1052 17.2003 13.8787 16.5359L18.004 12.9956C18.7775 12.3312 20.027 12.3312 20.8005 12.9956L22.417 14.384",
    stroke: "#292D32",
    strokeWidth: 1.37759,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddimage);
export default __webpack_public_path__ + "static/media/Addimage.f33b49112bd9db539a46e6210974c577.svg";
export { ForwardRef as ReactComponent };